import { render, staticRenderFns } from "./userReview.vue?vue&type=template&id=79b7c4e6&scoped=true&"
import script from "./userReview.vue?vue&type=script&lang=js&"
export * from "./userReview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79b7c4e6",
  null
  
)

export default component.exports